import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

/**
 * Ajusta automaticamente o viewport do mapa para que todos os marcadores
 * permaneçam visíveis.
 *
 * Caso exista apenas um marcador, centraliza o mapa nele e aplica
 * um zoom padrão.
 *
 * Permite definir espaçamentos internos para evitar que componentes
 * sobrepostos ao mapa ocultem marcadores.
 *
 * @param {Array<{lat: number, lng: number}>} markers
 * Lista de marcadores utilizados para calcular os limites do mapa.
 *
 * @param {{
 *   top?: number,
 *   bottom?: number,
 *   left?: number,
 *   right?: number
 * }} spaceOccupied
 * Espaço reservado por elementos sobrepostos ao mapa.
 *
 * @param {defaultZoom: number}
 * Zoom padrão aplicado quando existe apenas um marcador
 */
export const useFitBounds = (markers, spaceOccupied = {}, defaultZoom = 14) => {
  const map = useMap();

  const {
    top = 50,
    bottom = 50,
    left = 50,
    right = 50,
  } = spaceOccupied;

  useEffect(() => {
    if (!map || !markers?.length) return;

    const bounds = new google.maps.LatLngBounds();

    markers.forEach(marker => {
      bounds.extend({
        lat: marker.lat,
        lng: marker.lng,
      });
    });

    if (markers.length === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(defaultZoom);
    } else {
      map.fitBounds(bounds, {
        top,
        bottom,
        left,
        right,
      });
    }

  }, [map, markers, top, bottom, left, right]);
}